/* istanbul ignore file */
export * from './radio-list.component';
